import $ from 'jquery'

$( document ).on( 'cartzillagb_blog_post_block_output_success', function( e, el ) {
	$( el ).each( function() {
		if ( $( this ).find( '.js-slick-carousel' ).length ) {
			if( $('body,html').hasClass('rtl') ) {
				let slickAttributes = JSON.parse( $( this ).find( '.js-slick-carousel' ).attr( 'data-slick' ) )
				slickAttributes = { ...slickAttributes, rtl: true }
				$( this ).find( '.js-slick-carousel' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
			}
			$( this ).find( '.js-slick-carousel' ).slick()
		}
	} )
} )
